import axios from 'axios';

/**
 * Liste des actions
 */
export const Actions = {
    FETCH_TYPE_INDICATEURS_REQUEST: 'FETCH_TYPE_INDICATEURS_REQUEST',
    FETCH_TYPE_INDICATEURS_SUCCESS: 'FETCH_TYPE_INDICATEURS_SUCCESS',
    FETCH_TYPE_INDICATEURS_FAILURE: 'FETCH_TYPE_INDICATEURS_FAILURE',
    INVALIDATE_TYPE_INDICATEURS: 'INVALIDATE_TYPE_INDICATEURS'
};

/**
 * FETCH_TYPE_INDICATEURS
 * ActionCreator pour la récupération des indicateurs
 */
const fetchTypeIndicateursRequest = () => ({ type: Actions.FETCH_TYPE_INDICATEURS_REQUEST });
const fetchTypeIndicateursSuccess = items => ({ type: Actions.FETCH_TYPE_INDICATEURS_SUCCESS, items });
const fetchTypeIndicateursFailure = error => ({ type: Actions.FETCH_TYPE_INDICATEURS_FAILURE, error });
export const invalidateTypeIndicateurs = () => ({ type: Actions.INVALIDATE_TYPE_INDICATEURS });

export const fetchTypeIndicateurs = () => async (dispatch, getState) => {

    if (!getState().type.indicateurs.isLoading) {
        dispatch(fetchTypeIndicateursRequest());

        try {
            let response = await axios.get('api/types/indicateurs');
            dispatch(fetchTypeIndicateursSuccess(response.data));
        } catch (error) {
            console.error('fetchTypeIndicateurs : ', error);
            dispatch(fetchTypeIndicateursFailure(error));
        }
    }
};

const shouldFetchTypeIndicateurs = state => {
    let indicateurs = state.type.indicateurs;

    if (indicateurs.items.length === 0) return true;
    else if (indicateurs.isLoading) return false;
    else return indicateurs.didInvalidate;
};

export const fetchTypeIndicateursIfNeeded = () => (dispatch, getState) => {
    if (shouldFetchTypeIndicateurs(getState())) {
        return dispatch(fetchTypeIndicateurs());
    }
};
